import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteDawaaAction,
  GetAllDawaaAction,
} from "../../../../redux/actions/DawaAction";
import axios from "axios";
import fileDownload from "js-file-download";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
const Display = ({
  Datee,
  setDatee,
  Namemowakell,
  setNamemowakell,
  Sefamo,
  setSefamo,
  NameKhesm,
  setNameKhesm,
  SefaKhesm,
  setSefaKhesm,
  TypeDawa,
  setTypeDawa,
  NumberDawa,
  setNumberDawa,
  Year,
  setYear,
  Mawdodawa,
  setMawdodawa,
  TakadyDegree,
  setTakadyDegree,
  Mahkamaa,
  setMahkama,
  Numbercircle,
  setNumbercircle,
  Typecircle,
  setTypecircle,
  SummaryDawa,
  setSummaryDawa,
  Nots,
  setNots,
  setSelectedFile,
  selectedFile,
  NoteImg,
  setNoteImg,
  setKey,
  setDawaId,
  DawaId,
  setDawaEnded,
  DawaEnded,
  setEye,
  Eye,
  setIsEdit,
  isEdit,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const [showDelete, setshowDelete] = useState(false);
  const PageSize = 7;
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setDawaId(itemid);
  };
  const onPress = async (page) => {
    await dispatch(
      GetAllDawaaAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteDawaaAction(DawaId));
    setDawaId("");
    setshowDelete(false);
    setIsPress(false);
    setDatee("");
    setNamemowakell([]);
    setSefamo("");
    setNameKhesm([]);
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNoteImg("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setIsPress(false);
    setLoading(false);
  };

  const ALL = useSelector((state) => state.DawaR.Getdawa);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllDawaaAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  }, [Searchkey, Dateeto, Dateefrom]);
  const handleSubmit = async () => {
    await dispatch(
      GetAllDawaaAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  };
  const converterqoma = (msg) => {
    let parts = msg.split("-");
    return parts;
  };
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const Update = (item) => {
    setIsEdit(true);
    setKey("enter");
    setDawaId(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientDto.map((i) => i));
    setSefamo({ Id: item.ClientTypeId, Type: item.ClientType });
    setNameKhesm(item.DefendentDto.map((i) => i));
    setMahkama({ Id: item.CourtId, Name: item.CourtName });
    setSefaKhesm({ Id: item.DefendentTypeId, Type: item.DefendentType });
    setTypeDawa({ Id: item.LawSuitTypeId, Form: item.LawSuitType });
    setNumberDawa(() => converterqoma(item.Number)[0]);
    setYear(() => converterqoma(item.Number)[1]);
    setSummaryDawa(item.Summary || "");
    setNots(item.Note || "");
    setSelectedFile(item.FileUrl);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setDawaEnded(item.IsDone);
    setNumbercircle({
      Id: item.LocationNumberId,
      Number: item.LocationNumberName,
    });
    setTypecircle({ Id: item.LocationTypeId, Type: item.LocationTypeName });
    setTakadyDegree({ Id: item.LevelOfLawsuitId, Level: item.LevelOfLawsuit });
    setMawdodawa(item.Description || "");
  };
  const HandleShow = (item) => {
    setIsEdit(false);
    setEye(true);
    setKey("enter");
    setDawaId(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientDto.map((i) => i));
    setSefamo({ Id: item.ClientTypeId, Type: item.ClientType });
    setNameKhesm(item.DefendentDto.map((i) => i));
    setMahkama({ Id: item.CourtId, Name: item.CourtName });
    setSefaKhesm({ Id: item.DefendentTypeId, Type: item.DefendentType });
    setTypeDawa({ Id: item.LawSuitTypeId, Form: item.LawSuitType });
    setNumberDawa(() => converterqoma(item.Number)[0]);
    setYear(() => converterqoma(item.Number)[1]);
    setSummaryDawa(item.Summary || "");
    setNots(item.Note || "");
    setSelectedFile(item.FileUrl);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setDawaEnded(item.IsDone);
    setNumbercircle({
      Id: item.LocationNumberId,
      Number: item.LocationNumberName,
    });
    setTypecircle({ Id: item.LocationTypeId, Type: item.LocationTypeName });
    setTakadyDegree({ Id: item.LevelOfLawsuitId, Level: item.LevelOfLawsuit });
    setMawdodawa(item.Description || "");
  };
  const DEL = useSelector((state) => state.DawaR.DeletedawaId);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, lawsuit deleted Successfully"
          ) {
            dispatch(GetAllDawaaAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الموكل<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                صفة الموكل<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الخصم<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                نوع الدعوى<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                الرقم<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                المحكمة<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                حالة الدعوى<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.Data && ALL.Data.length > 0
              ? ALL.Data.map((item, idx) => (
                  <tr key={item} onDoubleClick={() => Update(item)}>
                    <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                    <td>{item.Clients}</td>
                    <td>{item.ClientType}</td>
                    <td>{item.Defendents}</td>
                    <td>{item.LawSuitType}</td>
                    <td>{converterqoma(item.Number)[0]}</td>
                    <td>{item.CourtName}</td>
                    <td>{item.IsDone ? "منتهية" : "مستمرة"}</td>
                    <td>
                      {" "}
                      {item.FileUrl !== null ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleShowpopup(item.FileUrl)}>
                            {" "}
                            <i className="fa-solid fa-paperclip"></i>
                          </button>
                          <span>{item.FileDescription}</span>
                        </>
                      ) : (
                        " "
                      )}
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => Update(item)}
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleShow(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={ALL ? ALL.TotalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer autoClose={1200} />
      </div>
    </>
  );
};
export default Display;
